import {Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import React, {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import {onCloseDeleteWarningDialog} from "../../../helpers/ComponentHelper";

const DeleteWarningModal = ({onDelete, deleteItemName, state}) => {

  const currentFormState = state.currentFormState;

  const onClose = () => {
    onCloseDeleteWarningDialog({state});
  }

  useEffect(()=> {
    if (currentFormState.warningDeleteButtonDisabled && currentFormState.warningWarningIconVisible) {
      const btnDelete = document.getElementById("delete-button");
      const warningIcon = document.getElementById("warning-icon");
      if (btnDelete && warningIcon) {
        btnDelete.setAttribute('disabled', '');
        warningIcon.classList.add("div-visible");
      }
    }
  }, [currentFormState])



  return (
    <Modal className = "mt-5"
      show={currentFormState.showDeleteWarning}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="form-header-warning" closeButton closeVariant="white">
        <Modal.Title>Uwaga</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {currentFormState.warningDescription}
      </Modal.Body>
      <Modal.Footer>
        <div className="row" style={{width: "100%"}}>
          <div className="col-md-6">
            <div>
              <span className="warning-icon" id="warning-icon"><FontAwesomeIcon icon={faExclamationTriangle}/></span>
            </div>
          </div>
          <div className="col-md-6" style={{textAlign: "right"}}>
            <Button variant="secondary mrx1" onClick={onClose}>
              Anuluj
            </Button>
            <Button variant="danger" id="delete-button" onClick={onDelete}>
              Usuń
            </Button>

          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )

}

export default DeleteWarningModal;

